import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { getMeta } from '../../selectors/meta';

export function PageMetaContainer() {
  const { title, description, keywords } = useSelector(getMeta);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  );
}
